<template>
    <div class="mb-4">
        <div
            v-if="!pageIsDisable"
            class="text-center center-block info-container"
        >
            <div class="alert alert-warning info-section">
                <button
                    style="margin: 0"
                    type="button"
                    class="btn"
                    data-toggle="modal"
                    data-target="#myModal"
                    @click="getSlots"
                >
                    Update Availability
                </button>
                <div>
                    <span class="big-font">
                        11&amp;12 September: you are available for
                        {{ data.first_group_display_limit }} slots.
                    </span>
                    <br />
                    <span class="big-font">
                        you have selected
                        {{ data.count_first_group_selected }} meetings
                    </span>
                </div>
                <div></div>
            </div>
        </div>
        <section v-show="pageIsDisable == false" class="section">
            <div class="container preference-text">
                Dear {{ client.full_titled_name }}
                <br />
                Welcome to your personal meeting request page.
                <strong>Please read the instructions carefully</strong>
                <br /><br />
                The <strong>counter</strong> above shows the number of meetings
                you can select which is based on the number of your available
                slots.
                <ul class="instruction-list-style">
                    <li>
                        <strong style="color: red"
                            >The maximum number of meetings you can select are
                            equal to the slots you have chosen + extra
                            {{ investor_selection_limit }} meetings.</strong
                        >
                        (Example: if you are available for 15 slots on September
                        11<sup>th</sup> &amp; 12<sup>th</sup>, you can choose up
                        to 20 meetings)
                    </li>
                    <li>
                        <strong>
                            If you wish to change your availability, please
                            click on Update Availability button
                        </strong>
                        on top left.
                    </li>
                    <li>
                        In case you are attending other conferences, please make
                        sure to
                        <strong
                            >update your meeting requests if you are meeting the
                            <u>same company</u> in another conference.</strong
                        >
                    </li>
                    <li>
                        We will do our best to accommodate your
                        <strong>high priority meetings.</strong>
                    </li>
                    <br>
                    To select a company:
                    <hr style="border: none; margin: 5px;">
                    <li>
                        Kindly
                        <span style="font-weight: bold">
                            click on the box (on the left)
                        </span>
                        next to the company name then select the
                        <span style="font-weight: bold">
                            meeting type & priority.
                        </span>
                        In order to successfully submit your meetings, all
                        fields must be complete for each company,
                        <span style="font-weight: bold">
                            any missing field will mark the company with a
                        </span>
                        <span style="color: red; font-weight: bold">
                            red frame.
                        </span>
                    </li>
                    <li>
                        For more info on management/IR representation from each
                        company,
                        <span style="font-weight: bold">
                            please hoover your mouse on the company name so you
                            can view companies’ attendee(s).</span
                        >
                    </li>
                    <li>
                        You can use the
                        <span style="font-weight: bold">filters</span> below to
                        help you search for companies you would like to meet.
                    </li>
                </ul>
            </div>
        </section>

        <section>
            <div class="container" style="text-align: center">
                <!-- Button trigger modal -->
                <!-- Modal -->
                <div
                    class="modal fade"
                    id="myModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                >
                    <div
                        class="modal-dialog"
                        role="document"
                        style="width: 1000px"
                    >
                        <div class="modal-content">
                            <div class="modal-header">
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h4 class="modal-title" id="myModalLabel">
                                    Update Availability
                                </h4>
                            </div>
                            <div class="modal-body">
                                <div v-if="modal_load">
                                    <img
                                        src="../../assets/img/icons/spinner.gif"
                                        alt="loading..."
                                    />
                                </div>
                                <div class="row" v-else>
                                    <div class="col-md-12">
                                        <fieldset>
                                            <h2 class="m-0 py-4">
                                                Preferred Dates to Attend
                                            </h2>
                                            <!-- <div>
                                                <label
                                                    >Time Zone
                                                    {{ timeZone.code }}</label
                                                >
                                                <VueSelect
                                                    style="
                                                        display: block;
                                                        margin-bottom: 1rem;
                                                        width: 100%;
                                                    "
                                                    :disabled="true"
                                                    placeholder="Select Time Zone"
                                                    :options="this.timeZones"
                                                    @input="changeTimeZone"
                                                    :value="this.timeZone.label"
                                                ></VueSelect>
                                            </div> -->
                                            <div class="my-table">
                                                <table>
                                                    <tr
                                                        class="dates_investor"
                                                        style="
                                                            font-size: 0.9rem;
                                                        "
                                                    >
                                                        <td>
                                                            <div
                                                                v-for="(
                                                                    timeslots,
                                                                    date
                                                                ) in agenda_slots"
                                                                :key="
                                                                    date +
                                                                    Math.random()
                                                                "
                                                            >
                                                                <div
                                                                    style="
                                                                        margin-bottom: 5px;
                                                                    "
                                                                >
                                                                    <span
                                                                        class="badge badge-info table-day"
                                                                        >{{
                                                                            availabiltyDateFormat(
                                                                                date,
                                                                                "DD-MM-YYYY"
                                                                            )
                                                                        }}
                                                                    </span>
                                                                </div>
                                                                <label
                                                                    class="table-slot"
                                                                    style="
                                                                        width: 70px;
                                                                    "
                                                                >
                                                                    <input
                                                                        style="
                                                                            margin: 0
                                                                                0px
                                                                                0
                                                                                2px !important;
                                                                        "
                                                                        @change="
                                                                            selectAllSlots
                                                                        "
                                                                        type="checkbox"
                                                                        :value="
                                                                            date
                                                                        "
                                                                    />
                                                                    all
                                                                </label>
                                                                <label
                                                                    class="table-slot"
                                                                    style="
                                                                        width: 80px;
                                                                    "
                                                                    v-for="timeslot in timeslots"
                                                                    :key="
                                                                        timeslot.id +
                                                                        Math.random()
                                                                    "
                                                                >
                                                                    <input
                                                                        style="
                                                                            margin: 0
                                                                                0px
                                                                                0
                                                                                2px !important;
                                                                        "
                                                                        v-model="
                                                                            client_slots
                                                                        "
                                                                        type="checkbox"
                                                                        :value="
                                                                            timeslot.id
                                                                        "
                                                                    />
                                                                    {{
                                                                        timeslot.start_time
                                                                    }}
                                                                </label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    :disabled="load_component"
                                    type="button"
                                    class="btn submission-btn"
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    :disabled="load_component"
                                    type="button"
                                    @click="updateSlots"
                                    class="btn submission-btn"
                                >
                                    Save changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section v-show="pageIsDisable == false" class>
            <div class="container">
                <div class="filter-wrapper">
                    <div>
                        <label>Select Company (Default: All)</label>
                        <VueSelect
                            placeholder="Select"
                            multiple
                            v-model="selected_filters.companies"
                            :options="filters.companies"
                        ></VueSelect>
                    </div>
                    <!-- <div>
                        <label>Select Country (Default: All)</label>
                        <VueSelect
                            placeholder="Select"
                            multiple
                            v-model="selected_filters.countries"
                            :options="filters.countries"
                        ></VueSelect>
                    </div> -->
                    <div>
                        <label>Select Sector (Default: All)</label>
                        <VueSelect
                            placeholder="Select"
                            multiple
                            v-model="selected_filters.sectors"
                            :options="filters.sectors"
                        ></VueSelect>
                    </div>
                    <div>
                        <label>Select Date (Default: All)</label>
                        <VueSelect
                            placeholder="Select"
                            multiple
                            v-model="selected_filters.date"
                            :options="filters.date"
                        ></VueSelect>
                    </div>
                    <div>
                        <button
                            @click="filtersDataSubmitted"
                            class="btn btn-outline-clr btn-sm"
                        >
                            Filter
                        </button>
                    </div>
                </div>
            </div>
        </section>
        <form @submit.prevent="preferencesSubmitted">
            <section v-show="pageIsDisable == false" class="section">
                <div class="container-fluid">
                    <div
                        id="validation-summary"
                        class="alert alert-danger"
                        v-show="validation_message != ''"
                    >
                        {{ validation_message }}
                    </div>
                    <div id="meeting-planner">
                        <img
                            v-if="loadingCompanies"
                            class="loading-companies"
                            src="../../../public/assets/img/preloader.gif"
                        />

                        <table
                            class="table pref-table"
                            v-if="!loadingCompanies"
                        >
                            <thead>
                                <tr>
                                    <th
                                        class="fixed-header"
                                        style="width: 5%"
                                    ></th>
                                    <th
                                        class="fixed-header"
                                        style="width: 5%; text-align: left"
                                    >
                                        Number
                                    </th>
                                    <th
                                        class="fixed-header"
                                        style="width: 15%; text-align: left"
                                    >
                                        Company
                                    </th>
                                    <!-- <th class="fixed-header" style="width: 12%">
                                        Country
                                    </th> -->
                                    <th
                                        class="fixed-header"
                                        style="width: 12%; text-align: left"
                                    >
                                        Sector
                                    </th>
                                    <th
                                        class="fixed-header"
                                        style="width: 15%; text-align: left"
                                    >
                                        Days of attendance
                                    </th>
                                    <th class="fixed-header" style="width: 15%">
                                        Meeting Type*
                                    </th>
                                    <th class="fixed-header" style="width: 15%">
                                        Meeting Priority *
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(
                                        company, index
                                    ) in data.companies_filteration"
                                    v-bind:data-index="index"
                                    v-bind:key="company.id + company.name"
                                    class="group accordion-header"
                                    :class="{
                                        'company-data-missing':
                                            inTheInvalidCompanies(company.id) &&
                                            company.isSelected,
                                        'accordion-header-active ui-state-active ui-corner-top':
                                            company.isSelected,
                                    }"
                                    :id="`company_id_${company.id}`"
                                    @click="
                                        updatePreferencesOption(
                                            company,
                                            'isSelected'
                                        );
                                        selectRow(company);
                                    "
                                >
                                    <td>
                                        <div>
                                            <span
                                                style="
                                                    display: flex;
                                                    justify-content: center;
                                                "
                                            >
                                                <span
                                                    v-if="
                                                        isCompanyDisabled(
                                                            company
                                                        )
                                                    "
                                                    class="disabled-help"
                                                    v-tooltip="{
                                                        html:
                                                            'tooltipHtml_' +
                                                            company.id,
                                                    }"
                                                ></span>
                                                <div v-show="false">
                                                    <div
                                                        :id="
                                                            'tooltipHtml_' +
                                                            company.id
                                                        "
                                                        class="my-tooltip-content"
                                                        v-html="
                                                            companyDisapleReason(
                                                                company
                                                            )
                                                        "
                                                    ></div>
                                                </div>
                                                <input
                                                    style="
                                                        margin: middle;
                                                        border-radius: 4px;
                                                        margin: 0px;
                                                    "
                                                    :disabled="
                                                        isCompanyDisabled(
                                                            company
                                                        )
                                                    "
                                                    @click.stop
                                                    @change="
                                                        updatePreferencesOption(
                                                            company,
                                                            'isSelected'
                                                        )
                                                    "
                                                    v-model="company.isSelected"
                                                    type="checkbox"
                                                    :value="company.id"
                                                />
                                            </span>
                                        </div>
                                    </td>
                                    <td style="text-align: left">
                                        #{{ index + 1 }}
                                    </td>
                                    <td style="text-align: left">
                                        <span
                                            :id="'tooltip_' + company.id"
                                            class="tooltip-content"
                                        >
                                            Presented By:
                                            <span
                                                style="display: block"
                                                v-for="(
                                                    presenter, $index
                                                ) in company.presenter_names"
                                                :key="$index + Math.random()"
                                            >
                                                {{ presenter }}
                                            </span>
                                        </span>
                                        <span
                                            v-tooltip="{
                                                html: 'tooltip_' + company.id,
                                            }"
                                            >{{ company.name }}</span
                                        >
                                    </td>
                                    <!-- <td>
                                        {{ company.country }}
                                    </td> -->
                                    <td style="text-align: left">
                                        {{ company.sector }}
                                    </td>
                                    <td style="text-align: left">
                                        <span
                                            v-for="(
                                                date, $index
                                            ) in company.available_dates"
                                            class="date"
                                            :key="$index + Math.random()"
                                            >{{ formatDate(date) }}</span
                                        >
                                    </td>
                                    <td style="text-align: left">
                                        <select
                                            :disabled="!company.isSelected"
                                            style="
                                                margin: 0;
                                                box-shadow: 0px 0px 5px -2px black;
                                            "
                                            @click.stop
                                            @change="
                                                updatePreferencesOption(
                                                    company,
                                                    'meeting_type'
                                                );
                                                removeErrorBox(company);
                                            "
                                            v-model="
                                                company.preferences.meeting_type
                                            "
                                        >
                                            <option disabled :value="0">
                                                [Select]
                                            </option>
                                            <option
                                                v-for="(
                                                    name, value
                                                ) in lists.meeting_type_list"
                                                :key="name + Math.random()"
                                                :value="value"
                                            >
                                                {{ name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            :disabled="!company.isSelected"
                                            style="
                                                margin: 0;
                                                box-shadow: 0px 0px 5px -2px black;
                                            "
                                            @click.stop
                                            @change="
                                                updatePreferencesOption(
                                                    company,
                                                    'meeting_priority'
                                                );
                                                removeErrorBox(company);
                                            "
                                            v-model="
                                                company.preferences
                                                    .meeting_priority
                                            "
                                        >
                                            <option disabled :value="0">
                                                [Select]
                                            </option>
                                            <option
                                                v-for="(
                                                    name, value
                                                ) in lists.meeting_priority_list"
                                                :key="name + Math.random()"
                                                :value="value"
                                            >
                                                {{ name }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- </transition-group> -->
                    </div>
                </div>
            </section>
            <section v-show="pageIsDisable == false" class="section section-sm">
                <div class="container">
                    <div class>
                        <div class="row">
                            <div class="col-md-12" style="text-align: center">
                                <input
                                    :disabled="isLoading"
                                    :value="submitText"
                                    type="submit"
                                    class="btn btn-outline-clr submission-btn"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </form>
        <section
            v-show="successs_message != '' || error_message != ''"
            class="section"
        >
            <div class="container">
                <div class="" v-show="successs_message != ''" style="minHeight: 480px;">
                    <br />
                    <p>
                        You have successfully submitted your meeting requests.
                        You will receive a confirmation email shortly including
                        the list of companies that you have requested meetings
                        with. You may edit your meeting request form using the
                        Edit link on the confirmation email.
                    </p>
                    <p>
                        The EFG Hermes scheduling team will organize your
                        itinerary according to the priority level you assigned
                        to your requests and will send you an e-mail with the
                        final schedule. <br />
                        <br />
                        For any further inquiries please contact
                        the&nbsp;scheduling team on:&nbsp;<a
                            href="mailto:schedules@efg-hermes.com"
                            >schedules@efg-hermes.com</a
                        ><br />
                        <br />
                    </p>
                    <div>
                        <br />
                    </div>
                    <p>&nbsp;</p>
                </div>
                <div class="alert alert-danger" v-show="error_message != ''">
                    <p v-html="error_message"></p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import collect from "collect.js";
var _ = require("lodash");
import Api from "@/Api";
import VueSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";
import momentTZ from "moment-timezone";
export default {
    name: "Preferences",
    components: { VueSelect },
    created() {
        $("#right").tooltip();
        $("#left").tooltip({
            placement: "left",
            title: "tooltip on left",
        });
        this.$emit('visibleOverFlow', true);
    },
    data() {
        return {
            selectedTimeZone: {
                code: "Asia/Saudi Arabia",
                label: "Asia/Saudi Arabia (GMT+03:00)",
            },
            loadingCompanies: false,
            successs_message: "",
            error_message: "",
            validation_message: "",
            pageIsDisable: false,
            updatedCompanies: [],
            errors: [],
            agenda_slots: [],
            client_slots: [],
            modal_load: false,
            load_component: false,
            invalid_selected_companies: [],
            data: {
                default_timezone: {
                    label:
                        "Europe/London" +
                        " (GMT" +
                        momentTZ.tz("Europe/London").format("Z") +
                        ")",
                    code: "Europe/London",
                },
                timezone: {
                    label:
                        "Europe/London" +
                        " (GMT" +
                        momentTZ.tz("Europe/London").format("Z") +
                        ")",
                    code: "Europe/London",
                },
                conference: {},
                companies_repo: [],
                companies_filteration: [], // it's will be pass to view
                count_available_slots: null,
                count_selected_companies: null,
                grouped_available_slots: null,
                grouped_days: null,
                grouped_selection_limit: null,
                first_group_limit: null,
                second_group_limit: null,
                third_group_limit: null,
                count_first_group_selected: null,
                count_second_group_selected: null,
                count_third_group_selected: null,

                first_group_display_limit: null,
                second_group_display_limit: null,
                third_group_display_limit: null,
            },
            lists: {
                meeting_priority_list: [],
                shareholder_list: [],
                meeting_type_list: [],
                knowledge_list: [],
            },
            filters: {
                companies: [],
                // countries: [],
                sectors: [],
                date: [],
            },
            selected_filters: {
                companies: [],
                // countries: [],
                sectors: [],
                date: [],
            },
            timeZone: {
                label: "",
                code: "",
            },
            isLoading: false,
            submitText: "Submit",
            user: JSON.parse(localStorage.getItem("client")),
            client: JSON.parse(localStorage.getItem("client")).client,
            investor_selection_limit: 0,
        };
    },
    computed: {
        ...mapState(["timeZones"]),
    },
    methods: {
        selectRow(company) {
            if (!company.isSelected) {
                if (!this.isCompanyDisabled(company)) {
                    company.isSelected = !company.isSelected;
                }
            } else {
                company.isSelected = !company.isSelected;
            }
        },
        formatDate(date) {
            //TODO:
            let parts = date.split("-");
            let d = new Date(parts[0], parts[1], parts[2]);
            let m = d.getMonth();
            let monthName = "";
            switch (m) {
                case 1:
                    monthName = "Jan";
                    break;
                case 2:
                    monthName = "Feb";
                    break;
                case 3:
                    monthName = "Mar";
                    break;
                case 4:
                    monthName = "Apr";
                    break;
                case 5:
                    monthName = "May";
                    break;
                case 6:
                    monthName = "Jun";
                    break;
                case 7:
                    monthName = "Jul";
                    break;
                case 8:
                    monthName = "Aug";
                    break;
                case 9:
                    monthName = "Sep";
                    break;
                case 10:
                    monthName = "Oct";
                    break;
                case 11:
                    monthName = "Nov";
                    break;
                case 12:
                    monthName = "Dec";
                    break;
            }

            let day = d.getDate();
            return monthName + ". " + day;
        },
        isGroupAvailableForCompany(group, company) {
            return this.groupOfCompany(company) == group;
        },
        groupOfCompany(company) {
            return this.groupOfDay(company.available_dates[0]);
        },
        allGroupsOfCompany(company) {
            return _.uniq(
                _.map(company.available_dates, (d) => this.groupOfDay(d))
            );
        },
        isCompanyDisabled(company) {
            if (company.isSelected) return false;
            if (!this.companyInAvailableSlots(company.available_slots_ids))
                return true;

            let groups = this.allGroupsOfCompany(company);
            let isValid = false;
            for (let i = 0; i < groups.length; i++) {
                let company_group = groups[i];

                let limit =
                    company_group == 1
                        ? this.data.first_group_limit
                        : company_group == 2
                        ? this.data.second_group_limit
                        : company_group == 3
                        ? this.data.third_group_limit
                        : 0;
                let selected =
                    company_group == 1
                        ? this.data.count_first_group_selected
                        : company_group == 2
                        ? this.data.count_second_group_selected
                        : this.data.count_third_group_selected;

                isValid = selected < limit;
                // console.log(this.data.count_first_group_selected,this.data.count_second_group_selected, this.data.count_second_group_selected, this.data.second_group_limit,company_group,  selected, limit, isValid);
                if (isValid) break;
            }
            if (isValid) return false;

            return true;
        },
        companyDisapleReason(company) {
            // console.log(company.name,this.data.available_slots, company.available_slots_ids, this.companyInAvailableSlots(company.available_slots_ids));
            if (!this.companyInAvailableSlots(company.available_slots_ids))
                return "Your availability doesn't match the company's availability.<br>TIP: If you wish to select this company, please make sure that you are available on the same day the company is attending & available in slots that are AM & PM as some companies have restricted availability. Please update your availability accordingly.";

            let groups = this.allGroupsOfCompany(company);
            let isValid = false;
            let last_group;
            for (let i = 0; i < groups.length; i++) {
                let company_group = groups[i];

                let limit =
                    company_group == 1
                        ? this.data.first_group_limit
                        : company_group == 2
                        ? this.data.second_group_limit
                        : company_group == 3
                        ? this.data.third_group_limit
                        : 0;
                let selected =
                    company_group == 1
                        ? this.data.count_first_group_selected
                        : company_group == 2
                        ? this.data.count_second_group_selected
                        : this.data.count_third_group_selected;
                isValid = selected < limit;
                last_group = company_group;
                if (!isValid) break;
            }

            //  if (groups.length > 1) {
            //     if (
            //        this.data.count_first_group_selected +
            //           this.data.count_second_group_selected >=
            //        this.data.first_group_limit + this.data.second_group_limit
            //     )
            //        return "You have exceeded your selection limit for all days of the conference";
            //  }

            if (!isValid) {
                if (this.data.is_all_slots_selected) {
                    return "You have reached the maximum number of meetings you can select.<br>TIP: if you wish to select this company, please unselect another company to replace it.";
                } else {
                    return "You have reached the maximum number of meeting selection based on your available slots.<br>TIP: If you wish to add more companies, please update/increase your availability";
                }
            }

            return "Your availability doesn’t match the day(s) of attendance of the company.<br>TIP: If you wish to select this company, please make sure that you are available on the same day the company is attending & available in slots that are AM & PM as some companies have restricted availability. Please update your availability accordingly.";
        },
        companyInAvailableSlots(company_slots) {
            for (let index in company_slots) {
                if (
                    this.data.available_slots.find(
                        (slot) => slot == company_slots[index]
                    )
                )
                    return true;
            }
            return false;
        },
        getSlots() {
            localStorage.setItem(
                "scroll_before_update_avail",
                $(document).scrollTop()
            );
            this.modal_load = true;
            Api()
                .get("auth/preferences/slots")
                .then(({ data }) => {
                    this.agenda_slots = data.agenda_slots;
                    this.client_slots = data.client_slots;
                    this.modal_load = false;

                    this.timeZone = this.data.default_timezone;
                    this.selectedTimeZone = this.data.default_timezone;

                    this.changeTimeZone({
                        code: this.data.timezone.code,
                        label: this.data.timezone.label,
                    });
                });
        },
        updateSlots() {
            if (!this.client_slots || this.client_slots.length == 0) {
                this.$toastr.e("Please select your availability");
                return;
            }
            localStorage.setItem(
                "THE_SAVED_COMPANY_ITEMS",
                JSON.stringify(this.updatedCompanies)
            );
            this.load_component = true;
            Api()
                .put("auth/preferences/slots", {
                    available_slot: this.client_slots,
                    timezone:
                        (this.timeZone && this.timeZone.code) ||
                        "Asia/Saudi Arabia",
                })
                .then(({ data }) => {
                    localStorage.setItem("THE_SAVED_FLAG", true);

                    //   let registered_user = JSON.parse( localStorage.getItem("registeration.client") );
                    //   if(registered_user) {
                    //       registered_user.timezone = this.timeZone && this.timeZone.code || 'Asia/Saudi Arabia';
                    //       localStorage.setItem('registeration.client' , JSON.stringify(registered_user) );
                    //   }

                    this.$toastr.s(
                        "SUCCESS MESSAGE",
                        "Slots have been updated successfully"
                    );
                    setTimeout(() => {
                        this.load_component = false;
                        location.reload();
                    }, 2000);
                });
        },
        selectAllSlots(e) {
            let el = e.target;
            let date = el.value;
            let timeslots = this.agenda_slots[date];
            for (let i in timeslots) {
                let slot = timeslots[i];
                if (el.checked == true) {
                    // registration_form.available_slot
                    if (!this.client_slots.includes(slot.id.toString())) {
                        this.client_slots.push(slot.id.toString());
                    }
                } else {
                    let indexToDelete = this.client_slots.indexOf(
                        slot.id.toString()
                    );
                    this.client_slots.splice(indexToDelete, 1);
                }
            }
        },
        mergeWithLocalStorage(companies) {
            let localValues = JSON.parse(
                localStorage.getItem("THE_SAVED_COMPANY_ITEMS")
            );
            let mergedArray = companies;
            for (let i = 0; i < companies.length; i++) {
                let exist = false;
                for (let j = 0; j < localValues.length; j++)
                    if (localValues[j].id === companies[i].id)
                        companies[i] = localValues[j];
            }
            return mergedArray;
        },
        getPageData() {
            let auth = this.client;
            if (auth.client_type.type != 1) {
                this.pageIsDisable = true;
                this.error_message = "You dont have access to this page";
                return;
            }
            this.loadingCompanies = true;
            Api()
                .get("auth/preferences")
                .then((response) => {
                    this.loadingCompanies = false;
                    this.pageIsDisable = false;
                    let data = response.data;
                    let companies = data.companies;
                    let count_available_slots = data.count_available_slots;
                    this.investor_selection_limit =
                        data.conference.investor_selection_limit;
                    this.data.conference = data.conference;
                    if (localStorage.getItem("THE_SAVED_COMPANY_ITEMS"))
                        this.data.companies_filteration =
                            this.mergeWithLocalStorage(companies);
                    else this.data.companies_filteration = companies;

                    if (localStorage.getItem("THE_SAVED_FLAG")) {
                        this.updatedCompanies = JSON.parse(
                            localStorage.getItem("THE_SAVED_COMPANY_ITEMS")
                        );
                    }

                    localStorage.removeItem("THE_SAVED_FLAG");
                    localStorage.removeItem("THE_SAVED_COMPANY_ITEMS");

                    this.data.count_available_slots = count_available_slots;
                    this.data.available_slots = data.available_slots;
                    this.data.is_all_slots_selected =
                        data.is_all_slots_selected;
                    this.data.companies_repo = companies;
                    let that = this;
                    _.each(this.data.companies_repo, function (company) {
                        if (!company.preferences)
                            company.preferences = {
                                meeting_type: 0,
                                meeting_priority: 0,
                                knowledge: 0,
                                shareholder: 0,
                            };
                        if (
                            company.isSelected &&
                            !that.companyInAvailableSlots(
                                company.available_slots_ids
                            )
                        ) {
                            company.isSelected = false;
                            company.preferences = {
                                meeting_type: 0,
                                meeting_priority: 0,
                                knowledge: 0,
                                shareholder: 0,
                            };
                            that.updatedCompanies.push(company);
                        }
                        if (company.preferences.meeting_type == 3) {
                            if (!data.MeetingTypeLists[3])
                                company.preferences.meeting_type = 0;
                        }
                    });
                    this.lists.meeting_priority_list =
                        data.MeetingPriorityLists;
                    this.lists.shareholder_list = data.ShareholderLists;

                    Object.keys(data.MeetingTypeLists).forEach((item) => {
                        let str = data.MeetingTypeLists[item];
                        if (str[str.length - 1] === "s") {
                            data.MeetingTypeLists[item] = str.slice(
                                0,
                                str.length - 1
                            );
                        }
                    });

                    this.lists.meeting_type_list = data.MeetingTypeLists;
                    this.lists.knowledge_list = data.KnowledgeLists;

                    this.data.grouped_available_slots =
                        data.grouped_available_slots;
                    this.data.grouped_days = data.grouped_days;
                    this.data.grouped_selection_limit =
                        data.grouped_selection_limit;
                    this.data.first_group_limit = data
                        .grouped_selection_limit[0]
                        ? data.grouped_selection_limit[0].selection_limit
                        : 0;
                    this.data.second_group_limit = data
                        .grouped_selection_limit[1]
                        ? data.grouped_selection_limit[1].selection_limit
                        : 0;
                    this.data.third_group_limit = data
                        .grouped_selection_limit[2]
                        ? data.grouped_selection_limit[2].selection_limit
                        : 0;
                    this.data.conference.investor_selection_limit =
                        this.data.first_group_limit +
                        this.data.second_group_limit +
                        this.data.third_group_limit;

                    // the number -3 & -5 depending on the difference between available meetings
                    this.data.first_group_display_limit = data
                        .grouped_selection_limit[0]
                        ? data.grouped_selection_limit[0].selection_limit - 5
                        : 0;
                    this.data.second_group_display_limit = data
                        .grouped_selection_limit[1]
                        ? data.grouped_selection_limit[1].selection_limit - 5
                        : 0;
                    this.data.third_group_display_limit = data
                        .grouped_selection_limit[2]
                        ? data.grouped_selection_limit[2].selection_limit - 5
                        : 0;
                    if (this.data.first_group_display_limit <= 0)
                        this.data.first_group_display_limit = 0;
                    if (this.data.second_group_display_limit <= 0)
                        this.data.second_group_display_limit = 0;
                    if (this.data.third_group_display_limit <= 0)
                        this.data.third_group_display_limit = 0;

                    this.scrollToLastVisitedCompany();

                    // Client data
                    let client_all_data = data.client;
                    let timezone = client_all_data.timezone
                        ? {
                              label:
                                  client_all_data.timezone +
                                  " (GMT" +
                                  momentTZ
                                      .tz(client_all_data.timezone)
                                      .format("Z") +
                                  ")",
                              code: client_all_data.timezone,
                          }
                        : this.data.default_timezone;
                    this.data.timezone = timezone;

                    // this.selectedTimeZone = {code: timezone.code, label: timezone.label};
                    // this.changeTimeZone(timezone);
                    // this.timeZone = timezone;
                })
                .then(() => {
                    this.createFilters();
                })
                .catch((error) => {
                    this.loadingCompanies = false;
                    if (error) {
                        //debugger;
                        if (error.response.status == 422) {
                            this.pageIsDisable = true;
                            this.error_message = `
                                Please note that the meeting preference page is closed. For any further info, please contact
                                <a href="mailto:schedules@efg-hermes.com" >schedules@efg-hermes.com</a>
                            `;
                            var err = error.response.data;
                            this.errors = err.errors;
                        } else if (error.response.status == 401) {
                            this.$store.dispatch("logout");
                            this.$router.push({
                                name: "login",
                                query: {
                                    redirect:
                                        this.$router.currentRoute.fullPath,
                                },
                            });
                        }
                    }
                });
        },
        removeErrorBox(company) {
            let prefs = company.preferences;
            if (
                // !prefs.knowledge ||
                !prefs.meeting_priority ||
                !prefs.meeting_type
                // || !prefs.shareholder
            )
                return;
            this.invalid_selected_companies =
                this.invalid_selected_companies.filter(
                    (comp) => comp.id !== company.id
                );
        },
        updatePreferencesOption(company, key) {
            this.updatedCompanies.push(company);
            // if (key != 'isSelected') {
            this.updatedCompanies = _.uniq(this.updatedCompanies);
            // localStorage.setItem('THE_SAVED_COMPANY_ITEMS', JSON.stringify(this.updatedCompanies));
            // }
        },
        inTheInvalidCompanies(id) {
            let company = this.invalid_selected_companies.filter(
                (company) => company.id === id
            );
            if (company.length) return true;
            return false;
        },
        preferencesSubmitted() {
            var scope = this;
            this.validation_message = "";
            let invalid = _.filter(
                this.data.companies_repo,
                (f) =>
                    f.isSelected &&
                    // !f.preferences.shareholder ||
                    (!f.preferences.meeting_type ||
                        !f.preferences.meeting_priority)
                // !f.preferences.knowledge
            );
            if (invalid && invalid.length) {
                this.invalid_selected_companies = invalid;
                setTimeout(() => {
                    if ($(`#company_id_${invalid[0].id}`).length > 0) {
                        $("html,body").animate(
                            {
                                scrollTop: parseInt(
                                    $(`#company_id_${invalid[0].id}`).offset()
                                        .top - 200
                                ),
                            },
                            500
                        );
                        this.validation_message =
                            "You must select the meeting type and priority.";
                    } else {
                        $("html,body").animate(
                            {
                                scrollTop: parseInt(
                                    $("#companies-table-wrapper").offset().top -
                                        300
                                ),
                            },
                            500
                        );

                        this.validation_message =
                            "Please clear the filter selection and complete the mandatory fields in the red box(es)";
                    }
                }, 100);

                return;
            }

            let no_selection = this.data.companies_repo.filter(
                (company) => company.isSelected
            );

            if (no_selection.length === 0) {
                setTimeout(() => {
                    $("html,body").animate(
                        {
                            scrollTop: parseInt(
                                $("#validation-summary").offset().top - 200
                            ),
                        },
                        500
                    );
                }, 100);

                this.validation_message = "You must select Your Preferences";
                return;
            }

            let data = collect({
                companies: this.updatedCompanies.map((company) => {
                    let preferences = company.preferences;
                    let newC = _.omit(company, [
                        "available_slots_ids",
                        "presenter_names",
                        "available_dates",
                        "country",
                        "sector",
                    ]);
                    newC = {
                        ...newC,
                        preferences: _.pick(preferences, [
                            "id",
                            "meeting_priority",
                            "shareholder",
                            "meeting_type",
                            "knowledge",
                        ]),
                    };
                    return newC;
                }),
            }).toJson();

            _.find(data, (c) => c.sharedholder);
            //   if (
            //     this.data.count_selected_companies > this.data.count_available_slots
            //   ) {
            //     alert(
            //       `Sorry, You cannot select more than ${this.data.count_available_slots} company and you now have selected ${this.data.count_selected_companies}.`
            //     );
            //     return;
            //   }
            this.isLoading = true;
            this.submitText = "Loading...";
            Api()
                .post("auth/preferences", data)
                .then((response) => {
                    this.pageIsDisable = true;
                    // let user = response.data.user;
                    this.isLoading = false;
                    this.submitText = "Submit";
                    this.successs_message =
                        "Your preferences submitted successfully.";
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.submitText = "Submit";
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;
                            this.error_message = err.errors[0].message;
                            // this.errors = err.errors;
                        }
                    }
                });
        },
        createFilters() {
            this.filters.companies = _.uniq(
                this.data.companies_repo.map((object) => object.name)
            ).sort((a, b) => a.localeCompare(b));

            // this.filters.countries = _.uniq(
            //     this.data.companies_repo.map((object) => object.country)
            // ).sort((a, b) => a.localeCompare(b));

            this.filters.sectors = _.uniq(
                this.data.companies_repo.map((object) => object.sector)
            ).sort((a, b) => a.localeCompare(b));

            let date_filters = this.data.companies_repo
                .map((object) => object.available_dates)
                .flat(2);

            this.filters.date = _.remove(_.uniq(date_filters), null)
                .sort((a, b) => new Date(a) - new Date(b))
                .map((date) => this.availabiltyDateFormat(date, "DD-MM-YYYY"));
        },
        filtersDataSubmitted() {
            var collection = collect(this.data.companies_repo);
            if (!_.isEmpty(this.selected_filters.companies))
                collection = collection.whereIn(
                    "name",
                    this.selected_filters.companies
                );
            // if (!_.isEmpty(this.selected_filters.countries))
            //     collection = collection.whereIn(
            //         "country",
            //         this.selected_filters.countries
            //     );
            if (!_.isEmpty(this.selected_filters.sectors))
                collection = collection.whereIn(
                    "sector",
                    this.selected_filters.sectors
                );
            if (!_.isEmpty(this.selected_filters.date)) {
                collection = collection.filter((company) => {
                    return (
                        company.available_dates.filter((date) =>
                            this.selected_filters.date.includes(
                                this.availabiltyDateFormat(date, "DD-MM-YYYY")
                            )
                        ).length > 0
                    );
                    // this.selected_filters.date.includes(value)
                });
            }
            this.data.companies_filteration = collection.all();
        },
        beforeEnter: function (el) {
            el.style.opacity = 0;
            el.style.height = 0;
        },
        enter: function (el, done) {
            var delay = el.dataset.index * 50;
            setTimeout(function () {
                Velocity(
                    el,
                    { opacity: 1, height: "100%" },
                    { complete: done }
                );
            }, delay);
        },
        leave: function (el, done) {
            var delay = el.dataset.index * 50;
            setTimeout(function () {
                Velocity(el, { opacity: 0, height: 0 }, { complete: done });
            }, delay);
        },
        groupOfDay(date) {
            let gd = _.find(this.data.grouped_days, (d) => d.date == date);
            if (gd) return gd.day_group;
            return 0;
        },
        countSelectedCompanies: function () {
            this.data.count_selected_companies = collect(
                this.data.companies_repo
            )
                .where("isSelected", true)
                .count();

            this.data.count_first_group_selected = _(this.data.companies_repo)
                .filter(
                    (c) =>
                        c.isSelected &&
                        _.every(
                            c.available_dates,
                            (d) => this.groupOfDay(d) == 1
                        )
                )
                .value().length;

            this.data.count_second_group_selected = _(this.data.companies_repo)
                .filter(
                    (c) =>
                        c.isSelected &&
                        _.every(
                            c.available_dates,
                            (d) => this.groupOfDay(d) == 2
                        )
                )
                .value().length;

            this.data.count_third_group_selected = _(this.data.companies_repo)
                .filter(
                    (c) =>
                        c.isSelected &&
                        _.every(
                            c.available_dates,
                            (d) => this.groupOfDay(d) == 3
                        )
                )
                .value().length;

            let bothSelected = _(this.data.companies_repo)
                .filter(
                    (c) =>
                        c.isSelected &&
                        _.some(
                            c.available_dates,
                            (d) => this.groupOfDay(d) == 1
                        ) &&
                        _.some(
                            c.available_dates,
                            (d) => this.groupOfDay(d) == 2
                        ) &&
                        _.some(
                            c.available_dates,
                            (d) => this.groupOfDay(d) == 3
                        )
                )
                .value().length;

            // console.log(this.data.count_first_group_selected,this.data.count_second_group_selected,bothSelected);
            while (
                this.data.count_first_group_selected <
                    this.data.first_group_limit &&
                bothSelected > 0
            ) {
                bothSelected--;
                this.data.count_first_group_selected += 1;
            }
            while (
                this.data.count_second_group_selected <
                    this.data.second_group_limit &&
                bothSelected > 0
            ) {
                bothSelected--;
                this.data.count_second_group_selected += 1;
            }
            while (
                this.data.count_third_group_selected <
                    this.data.third_group_limit &&
                bothSelected > 0
            ) {
                bothSelected--;
                this.data.count_third_group_selected += 1;
            }
            // console.log(this.data.count_first_group_selected,this.data.count_second_group_selected,bothSelected);
        },
        scrollToLastVisitedCompany() {
            if (localStorage.getItem("scroll_before_update_avail")) {
                setTimeout(() => {
                    $("html,body").animate(
                        {
                            scrollTop: parseInt(
                                localStorage.getItem(
                                    "scroll_before_update_avail"
                                )
                            ),
                        },
                        500
                    );
                    localStorage.removeItem("scroll_before_update_avail");
                }, 1000);
            }
        },
        changeTimeZone({ code, label }) {
            Object.keys(this.agenda_slots).forEach((date) => {
                this.agenda_slots[date] = this.agenda_slots[date].map(
                    (slot) => {
                        const startTime = slot.start_time.replace(/\(.+\)/, "");
                        slot.start_time = this.convertTimeZone(
                            `${slot.date} ${startTime}`,
                            this.timeZone.code || "Asia/Saudi Arabia",
                            code
                        );
                        return slot;
                    }
                );
            });

            this.selectedTimeZone.code = code;
            this.selectedTimeZone.label = label;
            this.timeZone.code = code;
            this.timeZone.label = label;
        },
        convertTimeZone(date, oldTimeZone, newTimeZone) {
            const time = momentTZ.tz(date, oldTimeZone);
            const oldTime = time.format("L");
            time.tz("Asia/Saudi Arabia");
            const londonTime = time.format("L");
            time.tz(newTimeZone);
            const newTime = time.format("L");
            const diff = moment(newTime).diff(moment(londonTime), "days");
            let res = time.format("HH:mm");
            if (diff) {
                res += "(" + (diff > 0 ? "+" : "") + diff + ")";
            }
            return res;
        },
        availabiltyDateFormat(date, dateFormat) {
            return moment(date).format(dateFormat);
        },
    },
    watch: {
        "data.companies_repo": function (newVal, oldVal) {
            this.countSelectedCompanies();
        },
        updatedCompanies: function (newVal, oldVal) {
            this.countSelectedCompanies();
        },
    },
    mounted() {
        this.getPageData();

        //   const regClient = JSON.parse( localStorage.getItem("registeration.client") );
        //   let registered_client_timezone = null;
        //   if(regClient && regClient.timezone) {
        //       let registered_client_timezone = regClient.timezone;
        //   }

        //   this.selectedTimeZone = registered_client_timezone ? { label : registered_client_timezone + " (GMT"+momentTZ.tz(registered_client_timezone).format('Z')+")" , code : registered_client_timezone  } : {label: '',code: ''} ;
        //   this.timeZone = registered_client_timezone ? { label : registered_client_timezone + " (GMT"+momentTZ.tz(registered_client_timezone).format('Z')+")" , code : registered_client_timezone  } : {label: '',code: ''} ;
    },
};
</script>

<style scoped>

.right-container{
    overflow: visible !important;
}
.preference-text {
    font-size: 16px;
    margin-bottom: 2rem;
}
.submission-btn {
    background-color: #004631;
    color: #fff;
}
.submission-btn:hover {
    background-color: #969400;
    color: #fff;
}
.my-table {
    text-align: left;
    border: 2px solid #ddd;
    padding: 2rem;
}
.table-slot {
    font-size: 15px;
    font-weight: normal;
}
.table-day {
    font-size: 17px;
}
.modal {
    top: 70px !important;
}
.my-tooltip-content {
    position: absolute !important;
    width: 340px !important;
    padding: 10px !important;
    left: 0px !important;
    top: 0px !important;
    background-color: black !important;
    text-align: center !important;
}
.slide-fade-enter-active {
    transition: all 0.5s ease;
}
.slide-fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    transition: all 0.5s ease;
    opacity: 0;
}
#meeting-plannder {
    font-size: 14px;
    padding-bottom: 5px;
}
#meeting-planner .accordion-panel .company-application table th {
    padding: 5px;
}
#meeting-planner .accordion-header {
    padding-bottom: 5px;
    margin-bottom: 2px;
}
#meeting-planner .accordion-header__item {
    padding: 0 5px;
    vertical-align: top;
}
#meeting-planner .accordion-header__item:first-child {
    vertical-align: middle;
}
#meeting-planner .accordion-header__item--date .date {
    margin: 0 2px;
    padding: 2px 4px;
}
.accordion-header__item {
    padding: 2px;
}
#meeting-planner .accordion-header__item:last-child .label {
    text-align: left;
    padding-right: 0;
}

.modal-dialog {
    width: 900px;
}
.btn-link-default {
    background: none;
    color: #003380 !important;
    text-decoration: underline;
    font-size: 0.9rem;
    text-transform: unset;
}
.disabled-help {
    width: 23px;
    height: 23px;
    text-align: center;
    color: #4b4b4b;
    position: absolute;
    z-index: 3;
    line-height: 23px;
    cursor: not-allowed;
    font-size: 1.4rem;
}
.loading-companies {
    margin: auto;
    display: flex;
}

.company-data-missing td:first-child {
    border-left: 2px solid red !important;
}
.company-data-missing td:last-of-type {
    border-right: 2px solid red !important;
}
.company-data-missing td {
    border-bottom: 2px solid red !important;
    border-top: 2px solid red !important;
}
strong {
    font-weight: bolder;
}

.pref-table {
    /* font-size: 0.8rem; */
    border-collapse: inherit !important;
}
/* .pref-table tbody tr {
    border-bottom: 1px solid #ccc;
} */
.pref-table thead tr th {
    padding: 10px;
    text-align: center;
    /* border-bottom: 1px solid #dddddd; */
}
.pref-table tbody tr td {
    padding: 4px;
    text-align: center;
    border: none;
    border-bottom: 1px solid #ccc;
}

.date {
    background-color: white;
    color: #004631;
    padding: 2px 4px;
    border-radius: 2px;
    margin: 2px;
    -webkit-box-shadow: 0px 0px 2px 1px #001c24;
    box-shadow: 0px 0px 2px 0px #001c24;
    display: inline-block;
    font-weight: bold;
}

.fixed-header {
    position: sticky;
    top: 130px;
    z-index: 1;
    background-color: #004631;
    color: #fff;
}

.info-container {
    position: sticky;
    top: 80px;
    z-index: 9;
    opacity: 0.99;
}

.info-section {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 0.8rem;
    padding: 5px;
}

.filter-wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
}

.instruction-list-style {
    list-style-type: disc;
    padding-left: 2rem;
}

.big-font {
    font-size: 1.8em;
}

.ui-state-active:hover {
    color: black !important;
}

.alert {
    padding: 5px !important;
}

@media (max-width: 992px) {
    .info-container {
        top: 197px;
    }
}
@media (max-width: 767px) {
    .fixed-header {
        /* z-index: 1; */
        position: unset;
        /* top: 183px; */
    }
    #meeting-planner {
        overflow: auto;
    }
    .info-section {
        flex-direction: column-reverse;
        align-items: center;
    }

    .filter-wrapper {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .filter-wrapper > div {
        width: 100%;
        margin-bottom: 1rem;
    }

    .filter-wrapper div:nth-child(4) {
        display: flex;
        justify-content: center;
    }
}
</style>
